export const config_settings = {
  //ecommerce credentials
  //AUTH_SERVER_URL : 'http://localhost:8084',
  //AUTH_SERVER_URL: 'http://52.36.79.49:8084',
  //RESOURCE_SERVER_URL : 'http://localhost:8083/store/1',
  /*
  AUTH_SERVER_URL: 'https://8u6o8x7jgj.execute-api.us-west-2.amazonaws.com/v1/client-auth',
  RESOURCE_SERVER_URL: 'https://8u6o8x7jgj.execute-api.us-west-2.amazonaws.com/v1/client-resource/store/1',
  PHOTO_SERVER_URL: 'https://8u6o8x7jgj.execute-api.us-west-2.amazonaws.com/v1/photo-server',
  */
  AUTH_SERVER_URL: 'https://a04o8lfqni.execute-api.us-west-2.amazonaws.com/v1-iff/client-auth',
  RESOURCE_SERVER_URL: 'https://a04o8lfqni.execute-api.us-west-2.amazonaws.com/v1-iff/client-resource/store/1',
  PHOTO_SERVER_URL: 'https://a04o8lfqni.execute-api.us-west-2.amazonaws.com/v1-iff/photo-server',
  //PHOTO_SERVER_URL: 'https://myawsbucketiff.s3.us-east-2.amazonaws.com',
  //PHOTO_SERVER_URL: 'http://localhost/armaq_serv/fotos',
  //PHOTO_SERVER_URL : 'http://iff-fotos-bucket.s3.us-west-2.amazonaws.com',
  //AUTH_SERVER_URL : 'http://earmaq-client-auth-lb-1157490916.us-west-2.elb.amazonaws.com:8084',
  //RESOURCE_SERVER_URL : 'http://earmaq-client-resource-lb-946996600.us-west-2.elb.amazonaws.com:8083',

  WEB_RESOURCE_SERVER_URL: 'http://localhost:8083/store/1',

  //OTHER_SERVICES_RESOURCE_SERVER_URL : 'http://localhost/armaq-php/public',
  // OTHER_SERVICES_RESOURCE_SERVER_URL : 'https://www.armasperu.com.pe/armaq-php/public',

  DOUBLE_LANGUAGE: false,
  STORE: 1,
};
